// Centralizovaný toast helper pro API chyby.
// Nahrazuje duplicitní pattern `toast.error(err.response?.data?.detail || 'Chyba')`
// v ~40 místech napříč stránkami.
import { toast } from 'sonner';

/**
 * Vytáhne human-readable detail z axios chyby a zobrazí jako toast.error.
 * Pokud chyba nemá detail, použije se fallback string.
 */
export function toastApiError(err, fallback = 'Nastala chyba') {
  const detail = err?.response?.data?.detail;
  const message =
    typeof detail === 'string' && detail
      ? detail
      : err?.message || fallback;
  toast.error(message);
}
